<div class="layout-topbar">

    <button
        #menubutton
        class="p-link layout-menu-button layout-topbar-button"
        (click)="layoutService.onMenuToggle()">

        <i class="pi pi-bars"></i>

    </button>

    <a class="layout-topbar-logo" routerLink="/dashboard">
        <img src="assets/images/logo.png" alt="logo">
    </a>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
            (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-bell"></i>
    </button>

    <!--    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">-->
    <!--        <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">-->
    <!--            <i class="pi pi-cog"></i>-->
    <!--            <span>Settings</span>-->
    <!--        </button>-->
    <!--    </div>-->

</div>
